import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Icon } from '@massds/mayflower-react';

import './index.scss';

const TimelineItem = (props) => {
  const {
    date, text, link, completed, details
  } = props;
  const circleClasses = classNames({
    'ma__timeline-item-content__circle': true,
    [`ma__timeline-item-content__circle--${completed && 'complete'}`]: completed,
    [`ma__timeline-item-content__circle--${!completed && 'incomplete'}`]: !completed
  });
  const contentClasses = classNames({
    'ma__timeline-item-content': true,
    [`ma__timeline-item-content--${completed && 'complete'}`]: completed,
    [`ma__timeline-item-content--${!completed && 'incomplete'}`]: !completed
  });
  return(
    <div className="ma__timeline-item">
      <div className={contentClasses}>
        {date && <time className="ma__timeline-item-content__time">{date}</time>}
        {text && <p className="ma__timeline-item-content__header">{text}</p>}
        {details && <p className="ma__timeline-item-content__details">{details}</p>}
        {link && (
          <a
            className="ma__timeline-item-content__link"
            href={link.href}
            target="_blank"
            rel="noopener noreferrer"
          >
            {link.text}
          </a>
        )}
        <span className={circleClasses}>
          {completed && <Icon name="inputsuccess" svgWidth={18} svgHeight={18} />}
        </span>
      </div>
    </div>
  );
};

TimelineItem.propTypes = {
  /** The date of the item. */
  date: PropTypes.string,
  /** The header of the timeline item. */
  text: PropTypes.string,
  /** Whether the item was completed or not */
  completed: PropTypes.bool,
  /** The details about the item. */
  details: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  /** A link object to render */
  link: PropTypes.shape({
    href: PropTypes.string,
    text: PropTypes.string
  })
};


const Timeline = (props) => {
  const { data, align } = props;
  const containerClasses = classNames({
    'ma__timeline-container': true,
    [`ma__timeline-container--${align}`]: align
  });
  return(
    data.length > 0 && (
    <div className={containerClasses}>
      {data.map((item, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <TimelineItem key={`timelineitem--${i}`} {...item} />
      ))}
    </div>
    )
  );
};

Timeline.propTypes = {
  /** An array of data to render a timeline items. */
  data: PropTypes.object,
  /** Whether to align the timeline left, right or center. */
  align: PropTypes.oneOf(['right', 'center', 'left'])
};

Timeline.defaultProps = {
  align: 'right'
};
export default Timeline;
